import * as React from 'react';
import { FontUpgrade, Box } from 'wix-style-react';
import { useReviewModalPrefetch } from '../../hooks/useReviewModalPrefetch';
import { ReviewAppPageHeader } from './review-app-page-header';
import { ReviewAppPageContent } from './review-app-page-content';
import { ReviewAppPageSuccessMessage } from './review-app-page-success-message';
import { biLogger } from '../../bi';
function ReviewAppPage(_a) {
    var appDefId = _a.appDefId, _b = _a.editorSdkVariant, editorSdkVariant = _b === void 0 ? false : _b, additionalBiData = _a.additionalBiData, t = _a.t;
    var appReviewData = useReviewModalPrefetch(appDefId, true, function () { });
    var _c = React.useState(false), isSubmitted = _c[0], setIsSubmitted = _c[1];
    var showReviewForm = !isSubmitted && appReviewData;
    function onSuccessfulSubmission(reviewData) {
        var _a;
        setIsSubmitted(true);
        biLogger
            .appMarketPostAppReview({
            appId: appDefId,
            msid: additionalBiData.msid,
            appScore: reviewData.rating.toString(),
            review_title: reviewData.title,
            has_description: Boolean(reviewData.description),
            review_body: reviewData.description,
            actionType: Boolean((_a = appReviewData === null || appReviewData === void 0 ? void 0 : appReviewData.previousReview) === null || _a === void 0 ? void 0 : _a.reviewId)
                ? 'edit_review'
                : 'add_review',
            post_type: 'new_review',
            tag_type: additionalBiData.tagType,
            market: additionalBiData.platform,
        })
            .catch(function (error) { return console.log(error); });
    }
    React.useEffect(function () {
        if (appReviewData) {
            biLogger
                .appMarketAddEditAppReviewClick({
                appId: appDefId,
                msid: additionalBiData.msid,
                actionType: Boolean(appReviewData.previousReview)
                    ? 'edit_review'
                    : 'add_review',
                post_type: 'new_review',
                tag_type: additionalBiData.tagType,
                market: additionalBiData.platform,
            })
                .catch(function (error) { return console.log(error); });
        }
    }, [appReviewData]);
    return (React.createElement(FontUpgrade, null,
        !editorSdkVariant && (React.createElement(Box, { direction: "vertical" },
            React.createElement(ReviewAppPageHeader, null))),
        React.createElement(Box, { align: "center", marginLeft: "18px", marginRight: "18px" },
            showReviewForm && (React.createElement(ReviewAppPageContent, { appDefId: appDefId, appReviewData: appReviewData, onSuccessfulSubmission: onSuccessfulSubmission, editorSdkVariant: editorSdkVariant, t: t })),
            isSubmitted && React.createElement(ReviewAppPageSuccessMessage, { t: t }))));
}
export { ReviewAppPage };
//# sourceMappingURL=review-app-page.js.map